import React from 'react';
import { setCurrentView } from 'core/utils';
import { CloseOutDetailViewStore } from 'modules/order/stores';
import { CloseOutDetailTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new CloseOutDetailViewStore(rootStore), 'closeOutDetailViewStore')
class CloseOutDetail extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CloseOutDetailTemplate {...this.props} />;
	}
}

export default CloseOutDetail;



// WEBPACK FOOTER //
// ./src/modules/order/pages/CloseOutDetail.jsx